class TabElement extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.tabButtons = this.querySelectorAll(".tab-search-button");
    this.tabContents = this.querySelectorAll(".tab-search-content");
    this.searchForm = this.querySelector("form.faq-page__search");
    this.searchInput = this.querySelector("#tabSearchInput");
    this.searchSumbitButton = this.querySelector(".faq-page__search button");
    this.allTabsContent = this.querySelectorAll(".tab-search-content[data-index=search] li")

    this.tabButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        this.openTab(event);
      });
    });

    this.searchInput.addEventListener('keyup', (event) => {
      this.handleSubmitButtonState();
      if(this.searchInput.value != ''){
        this.openTab(event);
        this.handleSearchResults(this.searchInput.value.toLowerCase())
      } else {
        this.openTab(null, "1");
      }    
    })

    this.searchForm.addEventListener('submit', (event) => {
      event.preventDefault();
      this.openTab(null, "search");
      this.handleSearchResults(this.searchInput.value.toLowerCase())
      this.querySelector('#tabsSearchResults').scrollIntoView({ behavior: "smooth"})
    })
  }

openTab(event, manualData) {
  let targetIndex;
  
  if (event) {
    targetIndex = event.target.dataset.target;
    
    this.tabButtons.forEach((button) => {
      button.removeAttribute("active");
    });

    event.target.setAttribute("active", "");
  } else {
    targetIndex = manualData;

    this.tabButtons.forEach((button) => {
      if (button.dataset.target === targetIndex) {
        button.setAttribute("active", "");
      } else {
        button.removeAttribute("active");
      }
    });
  }

  this.tabContents.forEach((content) => {
    content.removeAttribute("open");
  });

  const contentElement = this.querySelector(`.tab-search-content[data-index="${targetIndex}"]`);
  if (contentElement) {
    contentElement.setAttribute("open", "");
  }
}

  handleSubmitButtonState() {
    if (this.searchInput.value === ''){
      this.searchSumbitButton.setAttribute('disabled', '')
    } else {
      this.searchSumbitButton.removeAttribute('disabled')
    }
  }

  handleSearchResults(searchString) {
    const allTabsContentArray = Array.from(this.allTabsContent);

    let foundMatches = false;

    allTabsContentArray.forEach((content) => {
      const contentName = content.querySelector('.accordion__title').textContent;
      const contentText = content.querySelector('.accordion__content').textContent;

      const isMatch = contentName.toLowerCase().includes(searchString) || contentText.toLowerCase().includes(searchString);
      content.style.display = isMatch ? "block" : "none";

      if (isMatch) {
        foundMatches = true;
      }
    });

    document.querySelector(".no-results-message").style.display = foundMatches ? "none" : "block";
  }    
}


if (!customElements.get("tabs-with-search")) {
  customElements.define("tabs-with-search", TabElement);
}